import { faBold, faBolt, faPlug, faSheetPlastic, faSolarPanel } from "@fortawesome/free-solid-svg-icons";
import { TEXT_FILTER, TEXT_INFO, TEXT_LAYERS, TEXT_PROJECT_PARTNERS, TEXT_RANK, TOOL_TIP_TEXT } from "./text";
import { ColourRampType, SelectedLayersType } from "../types/dataTypes";
import { LAYER_IDS } from "./mapConsts";

export const ROUTES = {
  OVERVIEW: "overview",
  SURVEY: "survey",
  INFO: "info",
};

export const COLORS_BASE = {
  BRAND: { MAIN: "#2ba846", DARKER: "#0A2848"},
  SECONDARY: {MAIN: '#ff834e', LIGHTER: '#FF1F31', LIGHTEST: '#FFF9FB'}, 
  GREYS: { MAIN: "#eef0ed", LIGHTER: '#F4F5F6', DARKER: '#393E41', HIGHLIGHT: '#EBEBEB'},
  BLUE: {MAIN: '#4B88A2', DARK: '#2D5C7F', LIGHT: '#D6E4EB'},
  GREEN: {MAIN: "#cff0d6", DARK: "#9CBB9D", LIGHT:"#E1EFD6", SELECTED: "#578865"},
  YELLOW: {MAIN: "#EDD382"},
  ORANGE: {MAIN: "#FC9E4F"},
  RED: {MAIN: "#931621", LIGHT: "#FFD6D6"},
};

export const STYLES = { 
  BORDER_STYLE: `none`,
  BORDER_SECONDARY: `2px solid ${COLORS_BASE.GREYS.MAIN.replace(`"`, ``)}`,
  PAGE_MARGIN: 40,
  SIDEBAR_WIDTH: 400,
  NAV_WIDTH: 45,
}

export const COLORS = {
  FONT: { WARNING: COLORS_BASE.GREYS.MAIN, INACTIVE: COLORS_BASE.GREYS.DARKER, ACTIVE: COLORS_BASE.BRAND.MAIN},
  ICON: { MAIN: COLORS_BASE.BRAND.DARKER, SECONDARY: COLORS_BASE.SECONDARY.LIGHTER, WARN: COLORS_BASE.SECONDARY.MAIN },
  SIDEBAR: {HIGHLIGHT: COLORS_BASE.SECONDARY.MAIN},
  RATINGELEMENTS: {RATING_WIND: '#0075FF', RATING_WATER: '#003E87', 
    RATING_SOLAR: '#FFB800', RATING_ACCESS: '#9747FF', RATING_EXPORT: '#34C759'},
  MAP: {
    GOV: '#000000',
    GOV_BOUNDARY: '#000000',
    GOV_BOUNDARY_SELECTED: COLORS_BASE.GREEN.SELECTED,
    SELECTED_GOV: '#000000',
    GRID_HV: COLORS_BASE.RED.MAIN,
    GRID_LV: COLORS_BASE.ORANGE.MAIN,
    ICONS: '#000000',
    SETTLEMENTS: COLORS_BASE.BRAND.MAIN,
  },
  TOOLTIP: { },
  BUTTON: { MAIN: {  } },
  GRADIENT: [COLORS_BASE.BRAND.MAIN, '#314460', '#5b6a82', '#8794a6', '#b6c0cc', COLORS_BASE.GREYS.LIGHTER ],
  GR_RD_GRADIENT: { GR: "#00A878", YE: "#EDD382", OR: "#FC9E4F", RD: "#F4442E" }
};

export const FILTER_CONSTS = {
  COVER_PERC: 20,
  LANDCOVER: 80,
  DIST_VAL: 800,
  POP_AREA: 500,
  SLOPE: 3
}


export const PROJECT_PARTNERS = [
  {title: TEXT_PROJECT_PARTNERS.MIME.TITLE, name: TEXT_PROJECT_PARTNERS.MIME.NAME, contactName: TEXT_PROJECT_PARTNERS.MIME.CONTACT_NAME, contactEmail: TEXT_PROJECT_PARTNERS.MIME.CONTACT_EMAIL, websiteLink: "https://www.energiemines.gov.tn/fr/accueil/", websiteText: "www.energiemines.gov.tn", logo: 'temp.jpg'},
  {title: TEXT_PROJECT_PARTNERS.GIZ.TITLE, name: TEXT_PROJECT_PARTNERS.GIZ.NAME, contactName: TEXT_PROJECT_PARTNERS.GIZ.CONTACT_NAME, contactEmail: TEXT_PROJECT_PARTNERS.GIZ.CONTACT_EMAIL, websiteLink: "https://www.energiemines.gov.tn/fr/accueil/", websiteText: "www.somewebsite.org", logo: 'temp.jpg'},
  {title: TEXT_PROJECT_PARTNERS.GOPA.TITLE, name: TEXT_PROJECT_PARTNERS.GOPA.NAME, contactName: TEXT_PROJECT_PARTNERS.GOPA.CONTACT_NAME, contactEmail: TEXT_PROJECT_PARTNERS.GOPA.CONTACT_EMAIL, websiteLink: "https://www.energiemines.gov.tn/fr/accueil/", websiteText: "www.somewebsite.org", logo: 'temp.jpg'},
  {title: TEXT_PROJECT_PARTNERS.INT.TITLE, name: TEXT_PROJECT_PARTNERS.INT.NAME, contactName: TEXT_PROJECT_PARTNERS.INT.CONTACT_NAME, contactEmail: TEXT_PROJECT_PARTNERS.INT.CONTACT_EMAIL, websiteLink: "https://integration.org/environment-energy/", websiteText: "www.integration.org", logo: 'int.jpg'},
]


export const GLOBAL_SIZES = { NAV: 80 };

export const CSS = { MAX_WIDTH: "640px" };

export const BREAKPOINTS = {
  MOBILE: '768px',
};

export const PARAMS = { //ensure no special characters in params
  building_count: "building_c",
  grid_dist: "grid_d_km",
  building_density: "build_d_pe",
}
export const SLIDER_OPTIONS = [
  {text: TEXT_FILTER.SLIDER_OPTIONS.building_count, param: PARAMS.building_count, min: 100, max: 1000, minValInit: 100, maxValInit: 1000, units: ""
    , tooltip_text:TOOL_TIP_TEXT.building_count},
  {text: TEXT_FILTER.SLIDER_OPTIONS.grid_distance, param: PARAMS.grid_dist, min: 10, max: 60, minValInit: 10, maxValInit: 60, units: "km"
    , tooltip_text:TOOL_TIP_TEXT.grid_distance},
  {text: TEXT_FILTER.SLIDER_OPTIONS.building_density, param: PARAMS.building_density, min: 0.5, max: 10, minValInit: 0.5, maxValInit: 10, units: "%"
    , tooltip_text:TOOL_TIP_TEXT.building_density},
  ];

  export const COLOUR_WIND: ColourRampType = [
    { value: '<3', colour: '#f7fbff' },
    { value: 4, colour: '#e6f0f9' },
    { value: 5, colour: '#cddff1' },
    { value: 6, colour: '#a3cae5' },
    { value: 7, colour: '#75b4d8' },
    { value: 8, colour: '#4d95c8' },
    { value: 9, colour: '#2877b7' },
    { value: 10, colour: '#1d5f9e' },
    { value: 11, colour: '#134884' },
    { value: '>12', colour: '#08306b' },
  ];

  export const CLOUR_PV: ColourRampType = [
    { value: '<4.5', colour: '#d7191c' },
    { value: 4.7, colour: '#f07c4a' },
    { value: 5, colour: '#ffedab' },
    { value: 5.2, colour: '#addc76' },
    { value: '>5.2', colour: '#1a9641' },
  ];

  export const COLOUR_NES: ColourRampType = [
    { value: 'Isolated Customer', colour: '#faff39' },
    { value: 'Potential Mini-grid Location', colour: '#54b04a' },
    { value: 'Potential grid extension', colour: '#487bb6' },
  ];

//constant to define all data layers via name, type, source and styling, you can also define which data will be displayed on click via a popup
export const SELECTED_LAYER_INIITIAL: SelectedLayersType[] = [
  {layerId: LAYER_IDS.POWER_PLANTS, layerName: TEXT_LAYERS.POWER_PLANTS, icon: faBolt, toolTipText: TOOL_TIP_TEXT.POWER_PLANTS
    , isSelected: true, type: 'marker', markerClass: 'markerPowerPlants', geojsonName: 'power_plants',  
    detailDefinition: [{label: 'Name', key: 'name', unit: ''}, {label: 'Capacity (MW)', key: 'size', unit: ''},
      {label:'Technology', key: 'technology', unit: ''}, {label: 'Status', key: 'status', unit: ''},
      {label: 'Ongrid/Offgrid', key: 'on/offgrid', unit: ''},
    ]},
  {layerId: LAYER_IDS.SUBSTATIONS, layerName: TEXT_LAYERS.SUBSTATIONS
      , isSelected: true, type: 'circle', markerClass: 'NA', geojsonName: 'substations',colour: 'white', borderColor: COLORS.MAP.GRID_HV, toolTipText: TOOL_TIP_TEXT.SUBSTATIONS,
    },
  {layerId: LAYER_IDS.MINIGRIDS, layerName: TEXT_LAYERS.MINIGRIDS, icon: faSolarPanel, toolTipText: TOOL_TIP_TEXT.MINIGRIDS
    , isSelected: true, type: 'marker', markerClass: 'markerMinigrids', geojsonName: 'existing_minigrids',
    detailDefinition: [{label: 'Name', key: 'name', unit: ''}, {label: 'Size', key: 'kwp', unit: 'kWp'},{label: '# existing connections', key: 'presnt_con', unit: ''},
      {label: '# future connections', key: 'future_con', unit: ''}
    ]},
  {layerId: LAYER_IDS.WIND, layerName: TEXT_LAYERS.WIND, 
    isSelected: false, type: 'raster', markerClass: 'NA', geojsonName: 'NA',colourRamp: COLOUR_WIND,
    toolTipText: TOOL_TIP_TEXT.wind,
  },
  {layerId: LAYER_IDS.PV, layerName: TEXT_LAYERS.PV, 
    isSelected: false, type: 'raster', markerClass: 'NA', geojsonName: 'NA',colourRamp: CLOUR_PV,
    toolTipText: TOOL_TIP_TEXT.pv,
  },
  {layerId: LAYER_IDS.GRID, layerName: TEXT_LAYERS.GRID, toolTipText: TOOL_TIP_TEXT.GRIDLINES, isSelected: true, type: 'line', markerClass: '', geojsonName: 'final_grid_merged',colour: COLORS.MAP.GRID_HV},
  {layerId: LAYER_IDS.SETTLEMENTS_ALL_CENTROIDS, layerName: TEXT_LAYERS.SETTLEMENTS_ALL_CENTROIDS, colour: COLORS.MAP.SETTLEMENTS, borderColor: 'white'
      , isSelected: true, type: 'circle', markerClass: 'NA', geojsonName: 'settlements_all_centroids', toolTipText: TOOL_TIP_TEXT.SETTLEMENTS,},
  {layerId: LAYER_IDS.SURVEYED_SETTLEMENTS, layerName: TEXT_LAYERS.SURVEYED_SETTLEMENTS, colour: COLORS_BASE.SECONDARY.MAIN, borderColor: COLORS_BASE.BRAND.DARKER
    , isSelected: true, type: 'circle', markerClass: 'NA', geojsonName: 'NA', toolTipText: TOOL_TIP_TEXT.SURVEYED_SETTLEMENTS},
  {layerId: LAYER_IDS.NES, layerName: TEXT_LAYERS.NES, 
  isSelected: false, type: 'raster', markerClass: 'NA', geojsonName: 'NA',colourRamp: COLOUR_NES,
  toolTipText: TOOL_TIP_TEXT.NES,
},
]

export const DOWNLOAD_DATA_DEFINITION = [
  {name: 'Existing Minigrids', last_updated: '2021-01-01', data_type: 'Points, kml', download_link: 'existing_minigrids'},
  {name: 'Power Plants', last_updated: '2021-01-01', data_type: 'Points, kml', download_link: 'power_plants'},
  {name: 'Settlements', last_updated: '2021-01-01', data_type: 'Points, kml', download_link: 'settlements_all_centroids'},
  {name: 'Substations', last_updated: '2021-01-01', data_type: 'Points, kml', download_link: 'substations'},
  {name: 'Districts', last_updated: '2021-01-01', data_type: 'Polygons, kml', download_link: 'adm1'},
  {name: 'Electricity Grid High Voltage', last_updated: '2021-01-01', data_type: 'Lines, kml', download_link: 'grid_hv'},
  {name: 'Electricity Grid Medium Voltage', last_updated: '2021-01-01', data_type: 'Lines, kml', download_link: 'grid_lv'},
]

